<template>
  <td>
    <!-- <button class="k-primary k-button k-grid-edit-command" @click="editHandler">Edit</button>
    <button class="k-button k-grid-remove-command" @click="removeHandler">Remove</button> -->
    <span class="action-icon nt-eye-fill mx-1 k-link" @click="viewHandler"></span>
    <span class="action-icon nt-edit mx-1 k-link" @click="editHandler"></span>
    <span class="action-icon nt-trash-fill mx-1 k-link" @click="removeHandler"></span>
    <span
      type="button"
      class="mx-1 action-icon k-link"
      @click="auditHandler"
      v-b-toggle.sidebar-right
    >
      <span class="nt-clock"></span>
    </span>
  </td>
</template>
 
<script>
export default {
  props: {
    dataItem: Object,
    columnIndex: Number
  },
  watch: {
    dataItem: function(newVal) {
      this.item = newVal;
    }
  },
  methods: {
    editHandler: function() {
      this.$emit("edit", { dataItem: this.item });
    },
    removeHandler: function() {
      this.$emit("remove", { dataItem: this.item });
    },
    viewHandler: function() {
      this.$emit("view", { dataItem: this.item });
    },
    auditHandler: function() {
      this.$emit("audit", { dataItem: this.item });
      
    },
  },
  data: function() {
    return {
      item: { ...this.dataItem }
    };
  }
};
</script>
 
<style scoped>
</style>
